import { motion } from 'framer-motion'
import { LucideIcon } from 'lucide-react'

interface QuickAction {
  id: string
  label: string
  icon: LucideIcon
  color: string
  onClick: () => void
}

interface QuickActionsProps {
  actions: QuickAction[]
}

export function QuickActions({ actions }: QuickActionsProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {actions.map((action, index) => {
        const IconComponent = action.icon
        
        return (
          <motion.button
            key={action.id}
            onClick={action.onClick}
            className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="flex flex-col items-center space-y-3">
              <div className={`w-12 h-12 ${action.color} rounded-xl flex items-center justify-center`}>
                <IconComponent className="h-6 w-6 text-white" />
              </div>
              <span className="text-sm font-medium text-text-primary">
                {action.label}
              </span>
            </div>
          </motion.button>
        )
      })}
    </div>
  )
}















